import React from 'react';
import { Sparkles, ShieldCheck } from 'lucide-react';

/**
 * Left-side branding panel shown on the Login screen on desktop.
 */
export default function LoginBrandingPanel() {
  const year = new Date().getFullYear();
  return (
    <div className="hidden lg:flex flex-1 bg-gradient-to-br from-slate-900 via-slate-900 to-slate-800 relative overflow-hidden">
      <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-rose-500/20 blur-3xl" />
      <div className="absolute bottom-0 -left-32 h-96 w-96 rounded-full bg-rose-600/20 blur-3xl" />
      <div className="relative z-10 p-12 flex flex-col justify-between text-white">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-lg bg-gradient-to-br from-rose-500 to-rose-600 flex items-center justify-center">
            <Sparkles className="h-6 w-6 text-white" />
          </div>
          <span className="text-lg font-semibold">BeautyMateUK</span>
        </div>
        <div className="max-w-md">
          <h2 className="text-3xl font-bold leading-tight">Operations Control Room</h2>
          <p className="mt-3 text-slate-300">
            Manage partners, bookings, and payouts across Harrow's verified home-grooming network.
          </p>
          <div className="mt-8 flex items-center gap-2 text-sm text-slate-300">
            <ShieldCheck className="h-4 w-4 text-rose-300" />
            Admin-only access · JWT secured
          </div>
        </div>
        <p className="text-xs text-slate-400">© {year} BeautyMateUK Ltd.</p>
      </div>
    </div>
  );
}
